import React from 'react'

import { useFreeBuyBonusStore } from '@stores'
import { DeclineButtonsTemplate } from '@components/BonusSystemCommon'
import { Bonus } from 'game-ui-types'

interface FBBDeclineButtonsProps {
    bonus?: Bonus
}

const FBBDeclineButtons: React.FC<FBBDeclineButtonsProps> = ({ bonus }: FBBDeclineButtonsProps) => {
    const bonusSystemDeclineState = useFreeBuyBonusStore((state) => state.bonusSystemDeclineState)
    const setBonusSystemState = useFreeBuyBonusStore((state) => state.setBonusSystemState)
    const setBonusSystemDeclineState = useFreeBuyBonusStore((state) => state.setBonusSystemDeclineState)
    const setDeclinedBonusesIds = useFreeBuyBonusStore((state) => state.setDeclinedBonusesIds)

    return (
        <DeclineButtonsTemplate
            bonus={bonus}
            bonusSystemDeclineState={bonusSystemDeclineState}
            setBonusSystemState={setBonusSystemState}
            setBonusSystemDeclineState={setBonusSystemDeclineState}
            setDeclinedBonusesIds={setDeclinedBonusesIds}
        />
    )
}

export default FBBDeclineButtons
